const PERMISSION_KEY= "personalize:nebula_brain_history";
const PAGE_URL = {
    NEBULA_BRAIN_HISTORY_PAGE: "/admin/personalize/nebula-brain-history"
}

export {PERMISSION_KEY, PAGE_URL}

